import React, {useState, useEffect, useContext} from 'react'
import {useSelector} from 'react-redux'
import {Link, useParams} from 'react-router-dom'
import {ContextApp} from '../context/ContextApp'
import Spinner from './Spinner'

import promo3 from '../assets/banner/1.jpg'

export default (props) => {
  const contextApp = useContext(ContextApp)
  const {
    CountProductLoad,
    countProduct,
    categories,
    loading,
    paginate,
    paginateCount,
    setPaginateCount,
    parametersView,
    getProductsByCategoryBussiness,
    productsByCategory,
    addProductToCarShoppingById,
    productsBySearch,
    setCategoryShowClose,
    ClearProductLoad,
    cleanPaginateCount,
    reloadProductsByCategory,
    getProductsBySubCategory,
    resetRealoadProductsByCategory,
    cleanProductsBySubCategory,
    categoryNameFromMenu,
    getProductsByCategory,
    contador,
  } = contextApp

  //const [ paginateCount_, setpaginateCount ] = useState(paginateCount);
  console.log("este product list es el que se ejecuta");
  let val = paginate
  val = val + parametersView.paginate

  let cantidadProd = parametersView.countItem

  //let val2=paginateCount_;
  //setpaginateCount(paginateCount_+parametersView.countItem);
  //val2=val2+parametersView.countItem
  //console.log("VALOR:",val2);

  const [value, setValue] = useState(false)
  const [option, setOption] = useState(false)
  const [min, setMin] = useState('')
  const [max, setMax] = useState('')
  const [buscarPrice, setbuscarPrice] = useState(false)

  const listCategories = parametersView?.itemSelect?.subcategories.filter(
    category => category.enabled == 1 && category.id !== 65,
  )

  useEffect(() => {
    setCategoryShowClose()
    resetState()
  }, [productsByCategory])

  function resetState() {
    setTimeout(() => {
      //ClearProductLoad()
      cleanPaginateCount()
      resetRealoadProductsByCategory()
    }, 8000)
  }

  let proveedores = []
  let proveedoresID = []
  productsByCategory.forEach(element => {
    if (proveedores.indexOf(element.provider.name) == -1) {
      proveedores.push(element.provider.name)
      proveedoresID.push(element.provider.id)
    }
  })

  const [isChecked, setIsChecked] = useState(false)

  function handleChecked(event) {
    setIsChecked(!isChecked)

    if (!isChecked == true) {
      let prove = []

      productsByCategory.forEach(element => {
        if (element.provider.name == event.target.id) {
          prove.push(element)
        }
      })

      getProductsByCategoryBussiness(
        prove,
        parametersView.itemID,
        parametersView.itemSelect,
        parametersView.itemName,
        val,
      )
    } else {
      getProductsByCategory(
        parametersView.itemID,
        parametersView.itemSelect,
        parametersView.itemName,
        val,
        option,
        min,
        max,
      )
    }
  }

  let provePrice = []

  /*productsByCategory.forEach(element => {  
  
    if(provePrice.indexOf(element.batches.unit_price) == -1 ){
        provePrice.push(element.batches.unit_price) 
        }
    })*/

  const handleChangeMin = e => {
    setMin(e.target.value)
  }
  const handleChangeMax = e => {
    setMax(e.target.value)
  }
  const handleSearchPrice = () => {
    if (min >= 0 && max > 0) {
      if (max > min) {
        setValue(true)
        let items = []
        let itemsList = []

        productsByCategory.forEach(element => {
          element.batches.forEach(elementBatches => {
            items.push(elementBatches)
          })
        })

        const result = items.filter(
          batches =>
            parseFloat(batches.unit_price) >= parseFloat(min) &&
            parseFloat(batches.unit_price) <= parseFloat(max),
        )

        result.forEach(element => {
          // var precio = element.unit_price

          //if(precio >= min &&  precio <=max ) {
          if (itemsList.indexOf(element) == -1) {
            itemsList.push(element)
          }
          //}
        })

        let productolist = []

        itemsList.forEach(element => {
          productsByCategory.forEach(elementPrincipal => {
            if (elementPrincipal.id == element.product_id) {
              if (productolist.indexOf(elementPrincipal) == -1) {
                productolist.push(elementPrincipal)
              }
            }
          })
        })

        getProductsByCategoryBussiness(
          productolist,
          parametersView.itemID,
          parametersView.itemSelect,
          parametersView.itemName,
          val,
        )
        setbuscarPrice(true)
      } else {
        setMin('')
        setMax('')
      }
    } else {
      setMin('')
      setMax('')
    }
  }

  const handleSearchPriceDesc = () => {
    setbuscarPrice(false)
    setValue(false)
    setMin('')
    setMax('')
    setIsChecked(false)
    getProductsByCategory(
      parametersView.itemID,
      parametersView.itemSelect,
      parametersView.itemName,
      val,
      option,
    )
    setIsCheckedOR1(false)
    setIsCheckedOR2(false)
    setIsCheckedOR3(false)
    setIsCheckedOR4(false)
  }

  const [isCheckedOR1, setIsCheckedOR1] = useState(false)
  const [isCheckedOR2, setIsCheckedOR2] = useState(false)
  const [isCheckedOR3, setIsCheckedOR3] = useState(false)
  const [isCheckedOR4, setIsCheckedOR4] = useState(false)

  function MasNuevo(items, itemsList) {
    const sorting = items.sort((a, b) => {
      const aDate = new Date(a.created_at)
      const bDate = new Date(b.created_at)

      return bDate.getTime() - aDate.getTime()
    })

    let productolist = []
    sorting.forEach(element => {
      productsByCategory.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussiness(
      productolist,
      parametersView.itemID,
      parametersView.itemSelect,
      parametersView.itemName,
      val,
    )
  }

  function MasAntiguo(items, itemsList) {
    const sorting = items.sort((a, b) => {
      const aDate = new Date(a.created_at)
      const bDate = new Date(b.created_at)

      return aDate.getTime() - bDate.getTime()
    })

    let productolist = []
    sorting.forEach(element => {
      productsByCategory.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussiness(
      productolist,
      parametersView.itemID,
      parametersView.itemSelect,
      parametersView.itemName,
      val,
    )
  }

  function PrecioMasMinimo(items, itemsList) {
    itemsList = items.sort(
      (a, b) => parseFloat(a.unit_price) - parseFloat(b.unit_price),
    )

    let productolist = []

    itemsList.forEach(element => {
      productsByCategory.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussiness(
      productolist,
      parametersView.itemID,
      parametersView.itemSelect,
      parametersView.itemName,
      val,
    )
  }

  function PrecioMasAlto(items, itemsList) {
    itemsList = items.sort(
      (a, b) => parseFloat(b.unit_price) - parseFloat(a.unit_price),
    )

    let productolist = []

    itemsList.forEach(element => {
      productsByCategory.forEach(elementPrincipal => {
        if (elementPrincipal.id == element.product_id) {
          if (productolist.indexOf(elementPrincipal) == -1) {
            productolist.push(elementPrincipal)
          }
        }
      })
    })
    getProductsByCategoryBussiness(
      productolist,
      parametersView.itemID,
      parametersView.itemSelect,
      parametersView.itemName,
      val,
    )
  }

  const handleFilterView = e => {
    let items = []
    let itemsList = []
    productsByCategory.forEach(element => {
      element.batches.forEach(elementBatches => {
        items.push(elementBatches)
      })
    })
    setOption(e.target.value)
    switch (e.target.value) {
      case '1':
        PrecioMasMinimo(items, itemsList)
        break
      case '2':
        PrecioMasAlto(items, itemsList)
        break
      case '3':
        MasNuevo(items, itemsList)
        break
      case '4':
        MasAntiguo(items, itemsList)
        break
      default:
        getProductsByCategory(
          parametersView.itemID,
          parametersView.itemSelect,
          parametersView.itemName,
          val,
        )
        break
    }
  }

  const handlePriceFilter = value => {
    console.log('MAYOR' + value.max)
    console.log('MENOR' + value.min)
  }

  
  const params = useParams()

  const subcategory_filter = categories.filter(c => c.slug === params.categoria)[0]
  console.log(subcategory_filter);
  useEffect(() => {
    if(params.id) {
      getProductsByCategory(
        params.id,
        null,
        params.name,
        0,
        0,
        0,
        0,
      )
    }
  }, [params])
  
  return (
    <main id="content" role="main">
      <div class="bg-gray-13 bg-md-transparent">
        <div class="container">
          <div class="my-md-3">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb mb-3 flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble">
                <li class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1">
                  <a>Home</a>
                </li>
                <span>
                  <i class="fas fa-chevron-right"></i>
                </span>
                <li
                  class="breadcrumb-item flex-shrink-0 flex-xl-shrink-1 active"
                  aria-current="page"
                >
                  {parametersView.itemName}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {reloadProductsByCategory == true ? (
        <Spinner />
      ) : (
        <div class="container">
          <div class="row mb-8">
            <div class="d-none d-xl-block col-xl-3 col-wd-2gdot5">
              <div class="mb-8 border border-width-2 border-color-3 borders-radius-6">
                <ul id="sidebarNav" class="list-unstyled mb-0 sidebar-navbar">
                  <li>
                    <a class="dropdown-current active" href="#">
                      Sub Categorías{' '}
                      <span class="text-gray-25 font-size-12 font-weight-normal"></span>
                    </a>

                    <ul class="list-unstyled dropdown-list">
                      {subcategory_filter?.subcategories.map(subcategorie => (
                        <li
                          onClick={() => {
                            resetRealoadProductsByCategory()
                            getProductsBySubCategory(
                              subcategorie.id,
                              parametersView?.itemSelect,
                              subcategorie.name,
                              val,
                              0,
                              0,
                              0,
                            )
                          }}
                          class="border-color-1 list-group-item border-lg-down-0 flex-shrink-0 flex-xl-shrink-1"
                        >
                          <Link
                            to={`/productos/subcategoria/${subcategorie.slug}/${subcategorie.id}`}
                            class="nav-link u-header__nav-link"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {subcategorie.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="mb-6">
                <div class="border-bottom border-color-1 mb-5">
                  <h3 class="section-title section-title__sm mb-0 pb-2 font-size-18">
                    Filtros
                  </h3>
                </div>
                <div class="border-bottom pb-4 mb-4">
                  <h3 class="font-size-18 mb-3 font-weight-bold">Comercios</h3>
                  {proveedores.map((product, index) => {
                    return (
                      <div class="form-group d-flex align-items-center justify-content-between mb-2 pb-1">
                        <div class="custom-control custom-checkbox">
                          <input
                            id={product}
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleChecked}
                            class="custom-control-input"
                          />
                          <label class="custom-control-label" for={product}>
                            {product}
                            <span
                              class="text-gray-25 font-size-12 font-weight-normal"
                              style={{color: '#000', margin: '5px'}}
                            >
                              <Link
                                class="font-size-12 text-gray-5"
                                to={`/products/provider/${proveedoresID[index]}`}
                              >
                                Ver más
                              </Link>
                            </span>
                          </label>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="range-slider">
                  <h3 className="font-size-18 mb-3 font-weight-bold">
                    Rango de precio
                  </h3>
                  <div
                    class="border rounded-pill py-1 w-md-40 height-35 px-3 border-color-1"
                    style={{margin: '5px'}}
                  >
                    <div class="js-quantity row align-items-center">
                      <div class="col">
                        <input
                          value={min}
                          disabled={value == true ? 'disabled' : ''}
                          class="js-result form-control h-auto border-0 rounded p-0 shadow-none"
                          id="pMin"
                          name="pMin"
                          type="number"
                          min="1"
                          max="100"
                          placeholder="Min."
                          onChange={e => handleChangeMin(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="border rounded-pill py-1 w-md-40 height-35 px-3 border-color-1"
                    style={{margin: '5px'}}
                  >
                    <div class="js-quantity row align-items-center">
                      <div class="col">
                        <input
                          value={max}
                          disabled={value == true ? 'disabled' : ''}
                          class="js-result form-control h-auto border-0 rounded p-0 shadow-none"
                          id="pMax"
                          name="pMax"
                          type="number"
                          min="1"
                          max="100"
                          placeholder="Max."
                          onChange={e => handleChangeMax(e)}
                        />
                      </div>
                    </div>
                  </div>

                  {!buscarPrice ? (
                    <button
                      style={{margin: '5px'}}
                      type="submit"
                      onClick={handleSearchPrice}
                      class="btn px-4 btn-primary-dark-w py-2 rounded-lg"
                    >
                      <span style={{color: 'white'}}>Filtrar</span>
                    </button>
                  ) : (
                    <button
                      type="submit"
                      style={{margin: '5px'}}
                      onClick={handleSearchPriceDesc}
                      class="btn px-4 btn-primary-dark-w py-2 rounded-lg"
                    >
                      <span style={{color: 'white'}}>Borrar filtro</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/** */}
            <div class="col-xl-9 col-wd-9gdot5">
              <div class="d-block d-md-flex flex-center-between mb-3">
                <h3 class="font-size-25 mb-2 mb-md-0">
                  Categoría:<strong> {parametersView.itemName} </strong>
                </h3>
                <p class="font-size-14 text-gray-90 mb-0"></p>
              </div>
              <div class="bg-gray-1 flex-center-between borders-radius-9 py-1">
                <div class="d-xl-none"></div>
                <div class="px-3 d-none d-xl-block">
                  <ul class="nav nav-tab-shop" id="pills-tab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        id="pills-one-example1-tab"
                        data-toggle="pill"
                        href="#pills-one-example1"
                        role="tab"
                        aria-controls="pills-one-example1"
                        aria-selected="false"
                      >
                        <div class="d-md-flex justify-content-md-center align-items-md-center">
                          <i class="fa fa-th"></i>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="d-flex">
                  <form method="get">
                    <select
                      class="border rounded-pill py-1 w-md-90 height-35 px-3 border-color-1"
                      data-style="btn-sm bg-white font-weight-normal py-2 border text-gray-20 bg-lg-down-transparent border-lg-down-0"
                      onChange={handleFilterView}
                    >
                      <option value="0" selected>
                        Ordenar productos por :
                      </option>
                      <option value="1">
                        Ordenar por: Precio de más bajo a más alto
                      </option>
                      <option value="2">
                        Ordenar por: Precio de más alto a más bajo{' '}
                      </option>
                      <option value="3">Ordenar por: Lo Más Nuevo</option>
                      <option value="4">Ordenar por: Lo Más Antiguo</option>
                    </select>
                  </form>
                </div>
              </div>

              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade pt-2 show active in"
                  id="pills-one-example1"
                  role="tabpanel"
                  aria-labelledby="pills-one-example1-tab"
                  data-target-group="groups"
                >
                  <ul class="row list-unstyled products-group no-gutters">
                    {productsByCategory.map((product, index) => {
                      return (
                        <li
                          key={index}
                          className="col-6 col-md-4 col-wd-3 product-item"
                        >
                          <div class="product-item__outer h-100">
                            <div class="product-item__inner bg-white p-3">
                              <div class="product-item__body pb-xl-2">
                                <div class="mb-2">
                                  <Link
                                    to={`/products/provider/${product.batches[0].provider.id}`}
                                    class="font-size-12 text-gray-5"
                                  >
                                    {product.batches[0].provider.name}
                                  </Link>
                                </div>
                                <Link
                                  to={`/productos/${product.aeromall_categories && product.aeromall_categories.length > 0 ? product.aeromall_categories[0]?.slug : 'general'}/${product.slug}/${product.id}`}
                                  class="text-blue font-weight-bold"
                                >
                                  {' '}
                                  <h5 class="mb-1 product-item__title">
                                    {product.name}
                                  </h5>
                                  <div class="mb-2">
                                    <a class="d-block text-center">
                                      {product.campaing?.active == 1 ? (
                                        <span class="onsale">
                                          <span class="percentage">
                                            {product.campaing?.discount} % OFF
                                            {/* (((product.batches[0]?.regular_price-(product.batches[0].regular_price - (product.batches[0].regular_price*(product.campaing?.discount/100))).toFixed(2))/product.batches[0]?.regular_price)*100).toFixed(2) % OFF*/}
                                          </span>
                                        </span>
                                      ) : (
                                        ''
                                      )}
                                      <img
                                        style={{with: '100%'}}
                                        src={product.image_url}
                                        alt="Image Description"
                                      />
                                    </a>
                                  </div>
                                </Link>
                                <div class="flex-center-between mb-1">
                                  <div class="prodcut-price d-flex align-items-center position-relative">
                                    <ins class="font-size-20 tex-gray-6 text-decoration-none">
                                      {' '}
                                      {product.promo_price ? (
                                        <div className="discount_amount_promo_price">
                                          <strong>${product.promo_price}</strong>
                                          <span>${product?.batches[0]?.unit_price}</span>
                                        </div>
                                      ): `$${product?.batches[0]?.unit_price}`}
                                    </ins>    
                                    {product.promo_price ? <span className="discount_promo_price">Descuento del {product.active_campaign.discount_percentage.slice(0,2)}%</span> : null }         
                                  </div>                              
                                  <div class="d-none d-xl-block prodcut-add-cart"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {product.batches[0]?.stock === 0 ? (
                              <div className="none_stock_alert_product_item_home">
                                <span>agotado</span>
                              </div>
                            ) : null}
                            {product.promo_price ? (
                                  <div className="promo_price_show">
                                    <span>Promoción</span>
                                  </div>
                                ): null}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
              <nav>
                <center>
                  {!isChecked ? (
                    <>
                      {loading ? (
                        <>
                          <div class="d-grid gap-2 d-md-block">
                            <button class="btn px-4 btn-primary-dark-w py-2 rounded-lg">
                              <span style={{color: 'white'}}> Cargando...</span>
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div class="d-grid gap-2 d-md-block">
                            {countProduct == cantidadProd ? (
                              'No hay más existencias...'
                            ) : (
                              <>
                                <button
                                  type="submit"
                                  onClick={() => {
                                    CountProductLoad(productsByCategory.length)
                                    getProductsByCategory(
                                      parametersView.itemID,
                                      parametersView.itemSelect,
                                      parametersView.itemName,
                                      val,
                                      option == false ? 0 : option,
                                      min,
                                      max,
                                    )
                                    setPaginateCount(parametersView.paginate)
                                  }}
                                  class="btn px-4 btn-primary-dark-w py-2 rounded-lg"
                                >
                                  <span style={{color: 'white'}}>
                                    Mostrar más
                                  </span>
                                  <i
                                    class="fa fa-search"
                                    style={{color: 'white'}}
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  ) : null}
                </center>
              </nav>
            </div>
          </div>
        </div>
      )}
    </main>
  )
}
